import React from 'react';

import * as S from '../components/styles.css';
import createSlug from '../utils/createSlug';
import Layout from '../components/layout';
import Seo from '../components/seo';
import Pagination from '../components/pagination';
import renderList from '../components/renderList';

const BlogCategory = ({ data, pageContext }) => {
  const { currentPage, numPages, category, posts, canonicalUrl, nextUrl, prevUrl } = pageContext;

  return (
    <Layout>
      <Seo title={'Kategori ' + category.title} canonicalUrl={canonicalUrl} nextUrl={nextUrl} prevUrl={prevUrl} />

      <S.Author>Allt i kategorin</S.Author>

      <div style={{ marginBottom: '30px', marginTop: '20px' }}>
        <h1>Kategori: {category.title}</h1>
      </div>

      {posts.map(renderList)}

      <Pagination
        currentPage={currentPage}
        numPages={numPages}
        contextPage={`category/${createSlug(category.title)}`}
      />
    </Layout>
  );
};

export default BlogCategory;
